import { render, staticRenderFns } from "./IndustryCard.vue?vue&type=template&id=12366346&scoped=true&"
import script from "./IndustryCard.vue?vue&type=script&lang=js&"
export * from "./IndustryCard.vue?vue&type=script&lang=js&"
import style0 from "./IndustryCard.vue?vue&type=style&index=0&id=12366346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12366346",
  null
  
)

export default component.exports